import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

/**
 * Merges `features/orpheus/i18n/<locale>.json` under the `orpheus` namespace. English only: the
 * orphan Turkish catalog was deleted (it outlived ORP-19869's sweep) — never add `tr.json`.
 */
export function registerOrpheusMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('orpheus', locale)
}
